<template>
    <div class="columns is-variable is-1 note-tags hide-on-print">
        <div class="column is-narrow">
            <i @click="$emit('toggle_sidebars', !show_sidebars)"
               :class="show_sidebars ? 'fa-expand' : 'fa-compress'"
               class="pointer icon fas"></i>&nbsp;

            <i v-if="note.topic" @click="open" class="icon fas fa-file-import"></i>&nbsp;
            <i class="icon fas fa-tags"></i>
        </div>

        <div class="column">
            <multiselect
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                class="tags_multiselect"
                track-by="id"
                label="name"
                :loading="list.loading || remove_note_tag.loading || create_note_tag.loading"
                :disabled="!space_topic_permission('NOTE_UPDATE', note.topic)"
                :options="list.data.results || []"
                :value="note.note_tags"
                :taggable="true"
                :multiple="true"
                @search-change="search"
                @remove="remove_tag"
                @select="select"
                @tag="add_tag">

                <template slot="tag" slot-scope="{ option, remove }">
                    <tag :name="option.name"
                         :color="option.color"
                         :show_remove="true"
                         @remove="remove(option)"/>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import Tag from '../tag/Tag.vue';
import { open_in_topic } from '../../utils/helpers';

export default {
    name: 'NoteDetailsTopPanel',
    props: ['note', 'space', 'show_sidebars'],
    components: { Tag, Multiselect },
    computed: mapState('tags', ['list', 'create_note_tag', 'remove_note_tag']),
    methods: {
        search: _debounce(function (search) {
            this.$store.dispatch('tags/list', { space_id: this.space.id, search });
        }, 500),
        select(obj) {
            this.add_tag(obj.name);
        },
        open() {
            open_in_topic(this.space.id, this.note.topic.id, this.note.path, this.note.id);
        },
        async add_tag(name) {
            const tag = await this.$store.dispatch('tags/create_note_tag', {
                space_id: this.space.id,
                note_id: this.note.id,
                name,
            });

            this.$store.commit('notes/add_tag', tag);
        },
        async remove_tag(tag) {
            await this.$store.dispatch('tags/remove_note_tag', {
                space_id: this.space.id,
                note_id: this.note.id,
                tag_id: tag.id,
            });

            this.$store.commit('notes/remove_tag', tag.id);
        },
    },
};
</script>

<style scoped>
    .note-tags { margin-bottom: 0; }
    .tags_multiselect.multiselect--active { z-index: 2 !important; }
</style>
